require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./cljs.tools.reader.reader_types.js");

require("./cljs.tools.reader.impl.utils.js");

require("./cljs.tools.reader.impl.commons.js");

require("./cljs.tools.reader.impl.errors.js");

require("./goog.array.array.js");

require("./goog.string.string.js");

require("./goog.string.stringbuffer.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("cljs.tools.reader.js");
goog.provide('cljs.tools.reader');

cljs.tools.reader.macro_terminating_QMARK_ = function cljs$tools$reader$macro_terminating_QMARK_(ch) {
  var G__24712 = ch;

  switch (G__24712) {
    case "\"":
    case ";":
    case "@":
    case "^":
    case "`":
    case "~":
    case "(":
    case ")":
    case "[":
    case "]":
    case "{":
    case "}":
    case "\\":
      return true;
      break;

    default:
      return false;
  }
};

cljs.tools.reader.sb = new goog.string.StringBuffer();
/**
 * Read in a single logical token from the reader
 */

cljs.tools.reader.read_token = function cljs$tools$reader$read_token(rdr, kind, initch) {
  if (initch == null) {
    return cljs.tools.reader.impl.errors.throw_eof_at_start(rdr, kind);
  } else {
    cljs.tools.reader.sb.clear();
    var ch = initch;

    while (true) {
      if (cljs.tools.reader.impl.utils.whitespace_QMARK_(ch) || cljs.tools.reader.macro_terminating_QMARK_(ch) || ch == null) {
        if (ch == null) {} else {
          rdr.cljs$tools$reader$reader_types$IPushbackReader$unread$arity$2(null, ch);
        }

        return cljs.tools.reader.sb.toString();
      } else {
        cljs.tools.reader.sb.append(ch);
        var G__24836 = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);
        ch = G__24836;
        continue;
      }

      break;
    }
  }
};

cljs.tools.reader.read_dispatch = function cljs$tools$reader$read_dispatch(rdr, _, opts, pending_forms) {
  var temp__5802__auto__ = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

  if (cljs.core.truth_(temp__5802__auto__)) {
    var ch = temp__5802__auto__;
    var temp__5802__auto____$1 = cljs.tools.reader.dispatch_macros.cljs$core$IFn$_invoke$arity$1 ? cljs.tools.reader.dispatch_macros.cljs$core$IFn$_invoke$arity$1(ch) : cljs.tools.reader.dispatch_macros.call(null, ch);

    if (cljs.core.truth_(temp__5802__auto____$1)) {
      var dm = temp__5802__auto____$1;
      return dm.cljs$core$IFn$_invoke$arity$4 ? dm.cljs$core$IFn$_invoke$arity$4(rdr, ch, opts, pending_forms) : dm.call(null, rdr, ch, opts, pending_forms);
    } else {
      var G__24713 = function () {
        var G__24717 = rdr;
        G__24717.cljs$tools$reader$reader_types$IPushbackReader$unread$arity$2(null, ch);
        return G__24717;
      }();

      var G__24714 = ch;
      var G__24715 = opts;
      var G__24716 = pending_forms;
      return cljs.tools.reader.read_tagged.cljs$core$IFn$_invoke$arity$4 ? cljs.tools.reader.read_tagged.cljs$core$IFn$_invoke$arity$4(G__24713, G__24714, G__24715, G__24716) : cljs.tools.reader.read_tagged.call(null, G__24713, G__24714, G__24715, G__24716);
    }
  } else {
    return cljs.tools.reader.impl.errors.throw_eof_at_dispatch(rdr);
  }
};

cljs.tools.reader.read_unmatched_delimiter = function cljs$tools$reader$read_unmatched_delimiter(rdr, ch, opts, pending_forms) {
  return cljs.tools.reader.impl.errors.throw_unmatch_delimiter(rdr, ch);
};

cljs.tools.reader.read_regex = function cljs$tools$reader$read_regex(rdr, ch, opts, pending_forms) {
  var sb = new goog.string.StringBuffer();
  var ch__$1 = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

  while (true) {
    if ("\"" === ch__$1) {
      return cljs.core.re_pattern(cljs.core.str.cljs$core$IFn$_invoke$arity$1(sb));
    } else {
      if (ch__$1 == null) {
        return cljs.tools.reader.impl.errors.throw_eof_reading.cljs$core$IFn$_invoke$arity$variadic(rdr, new cljs.core.Keyword(null, "regex", "regex", 939488856), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([sb], 0));
      } else {
        sb.append(ch__$1);

        if ("\\" === ch__$1) {
          var ch_24837__$2 = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

          if (ch_24837__$2 == null) {
            cljs.tools.reader.impl.errors.throw_eof_reading.cljs$core$IFn$_invoke$arity$variadic(rdr, new cljs.core.Keyword(null, "regex", "regex", 939488856), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([sb], 0));
          } else {}

          sb.append(ch_24837__$2);
        } else {}

        var G__24838 = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);
        ch__$1 = G__24838;
        continue;
      }
    }

    break;
  }
};

cljs.tools.reader.read_unicode_char = function cljs$tools$reader$read_unicode_char(var_args) {
  var G__24719 = arguments.length;

  switch (G__24719) {
    case 4:
      return cljs.tools.reader.read_unicode_char.cljs$core$IFn$_invoke$arity$4(arguments[0], arguments[1], arguments[2], arguments[3]);
      break;

    case 5:
      return cljs.tools.reader.read_unicode_char.cljs$core$IFn$_invoke$arity$5(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

cljs.tools.reader.read_unicode_char.cljs$core$IFn$_invoke$arity$4 = function (token, offset, length, base) {
  var l = offset + length;

  if (cljs.core.count(token) === l) {} else {
    cljs.tools.reader.impl.errors.throw_invalid_unicode_literal(null, token);
  }

  var i = offset;
  var uc = 0;

  while (true) {
    if (i === l) {
      return String.fromCharCode(uc);
    } else {
      var d = cljs.tools.reader.impl.utils.char_code(cljs.core.nth.cljs$core$IFn$_invoke$arity$2(token, i), base);

      if (d === -1) {
        return cljs.tools.reader.impl.errors.throw_invalid_unicode_digit_in_token(null, cljs.core.nth.cljs$core$IFn$_invoke$arity$2(token, i), token);
      } else {
        var G__24840 = i + 1;
        var G__24841 = d + uc * base;
        i = G__24840;
        uc = G__24841;
        continue;
      }
    }

    break;
  }
};

cljs.tools.reader.read_unicode_char.cljs$core$IFn$_invoke$arity$5 = function (rdr, initch, base, length, exact_QMARK_) {
  var i = 1;
  var uc = cljs.tools.reader.impl.utils.char_code(initch, base);

  while (true) {
    if (uc === -1) {
      return cljs.tools.reader.impl.errors.throw_invalid_unicode_digit(rdr, initch);
    } else {
      if (!(i === length)) {
        var ch = rdr.cljs$tools$reader$reader_types$Reader$peek_char$arity$1(null);

        if (cljs.core.truth_(function () {
          var or__4126__auto__ = cljs.tools.reader.impl.utils.whitespace_QMARK_(ch);

          if (or__4126__auto__) {
            return or__4126__auto__;
          } else {
            var or__4126__auto____$1 = cljs.tools.reader.macros.cljs$core$IFn$_invoke$arity$1 ? cljs.tools.reader.macros.cljs$core$IFn$_invoke$arity$1(ch) : cljs.tools.reader.macros.call(null, ch);

            if (cljs.core.truth_(or__4126__auto____$1)) {
              return or__4126__auto____$1;
            } else {
              return ch == null;
            }
          }
        }())) {
          if (cljs.core.truth_(exact_QMARK_)) {
            return cljs.tools.reader.impl.errors.throw_invalid_unicode_len(rdr, i, length);
          } else {
            return String.fromCharCode(uc);
          }
        } else {
          var d = cljs.tools.reader.impl.utils.char_code(ch, base);
          rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

          if (d === -1) {
            return cljs.tools.reader.impl.errors.throw_invalid_unicode_digit(rdr, ch);
          } else {
            var G__24843 = i + 1;
            var G__24844 = d + uc * base;
            i = G__24843;
            uc = G__24844;
            continue;
          }
        }
      } else {
        return String.fromCharCode(uc);
      }
    }

    break;
  }
};

cljs.tools.reader.read_unicode_char.cljs$lang$maxFixedArity = 5;
cljs.tools.reader.upper_limit = "\uD7FF".charCodeAt(0);
cljs.tools.reader.lower_limit = "\uE000".charCodeAt(0);

cljs.tools.reader.valid_octal_QMARK_ = function cljs$tools$reader$valid_octal_QMARK_(token, base) {
  return parseInt(token, base) <= 255;
};
/**
 * Read in a character literal
 */


cljs.tools.reader.read_char_STAR_ = function cljs$tools$reader$read_char_STAR_(rdr, backslash, opts, pending_forms) {
  var ch = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

  if (!(ch == null)) {
    var token = cljs.tools.reader.macro_terminating_QMARK_(ch) || cljs.tools.reader.impl.utils.whitespace_QMARK_(ch) ? cljs.core.str.cljs$core$IFn$_invoke$arity$1(ch) : cljs.tools.reader.read_token(rdr, new cljs.core.Keyword(null, "character", "character", 380652989), ch);
    var token_len = token.length;

    if (1 === token_len) {
      return token.charAt(0);
    } else {
      if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(token, "newline")) {
        return "\n";
      } else {
        if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(token, "space")) {
          return " ";
        } else {
          if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(token, "tab")) {
            return "\t";
          } else {
            if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(token, "backspace")) {
              return "\b";
            } else {
              if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(token, "formfeed")) {
                return "\f";
              } else {
                if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(token, "return")) {
                  return "\r";
                } else {
                  if (cljs.core.truth_(goog.string.startsWith(token, "u"))) {
                    var c = cljs.tools.reader.read_unicode_char.cljs$core$IFn$_invoke$arity$4(token, 1, 4, 16);
                    var ic = c.charCodeAt(0);

                    if (ic > cljs.tools.reader.upper_limit && ic < cljs.tools.reader.lower_limit) {
                      return cljs.tools.reader.impl.errors.throw_invalid_character_literal(rdr, ic.toString(16));
                    } else {
                      return c;
                    }
                  } else {
                    if (cljs.core.truth_(goog.string.startsWith(token, "o"))) {
                      var len = token_len - 1;

                      if (len > 3) {
                        return cljs.tools.reader.impl.errors.throw_invalid_octal_len(rdr, token);
                      } else {
                        var offset = 1;
                        var base = 8;
                        var uc = cljs.tools.reader.read_unicode_char.cljs$core$IFn$_invoke$arity$4(token, offset, len, base);

                        if (!cljs.tools.reader.valid_octal_QMARK_(cljs.core.subs.cljs$core$IFn$_invoke$arity$2(token, offset), base)) {
                          return cljs.tools.reader.impl.errors.throw_bad_octal_number(rdr);
                        } else {
                          return uc;
                        }
                      }
                    } else {
                      return cljs.tools.reader.impl.errors.throw_unsupported_character(rdr, token);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  } else {
    return cljs.tools.reader.impl.errors.throw_eof_in_character(rdr);
  }
};

cljs.tools.reader.starting_line_col_info = function cljs$tools$reader$starting_line_col_info(rdr) {
  if (cljs.tools.reader.reader_types.indexing_reader_QMARK_(rdr)) {
    return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [rdr.cljs$tools$reader$reader_types$IndexingReader$get_line_number$arity$1(null), rdr.cljs$tools$reader$reader_types$IndexingReader$get_column_number$arity$1(null) - 1 | 0], null);
  } else {
    return null;
  }
};

cljs.tools.reader.ending_line_col_info = function cljs$tools$reader$ending_line_col_info(rdr) {
  if (cljs.tools.reader.reader_types.indexing_reader_QMARK_(rdr)) {
    return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [rdr.cljs$tools$reader$reader_types$IndexingReader$get_line_number$arity$1(null), rdr.cljs$tools$reader$reader_types$IndexingReader$get_column_number$arity$1(null)], null);
  } else {
    return null;
  }
};

if (typeof cljs !== 'undefined' && typeof cljs.tools !== 'undefined' && typeof cljs.tools.reader !== 'undefined' && typeof cljs.tools.reader.READ_EOF !== 'undefined') {} else {
  cljs.tools.reader.READ_EOF = new Object();
}

if (typeof cljs !== 'undefined' && typeof cljs.tools !== 'undefined' && typeof cljs.tools.reader !== 'undefined' && typeof cljs.tools.reader.READ_FINISHED !== 'undefined') {} else {
  cljs.tools.reader.READ_FINISHED = new Object();
}

cljs.tools.reader._STAR_read_delim_STAR_ = false;

cljs.tools.reader.read_delimited_internal = function cljs$tools$reader$read_delimited_internal(kind, delim, rdr, opts, pending_forms) {
  var vec__24720 = cljs.tools.reader.starting_line_col_info(rdr);
  var start_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24720, 0, null);
  var start_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24720, 1, null);
  var delim__$1 = cljs.tools.reader.impl.utils.char$(delim);
  var a = cljs.core.transient$(cljs.core.PersistentVector.EMPTY);

  while (true) {
    var form = cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6(rdr, false, cljs.tools.reader.READ_EOF, delim__$1, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, false, cljs.tools.reader.READ_EOF, delim__$1, opts, pending_forms);

    if (form === cljs.tools.reader.READ_FINISHED) {
      return cljs.core.persistent_BANG_(a);
    } else {
      if (form === cljs.tools.reader.READ_EOF) {
        return cljs.tools.reader.impl.errors.throw_eof_delimited.cljs$core$IFn$_invoke$arity$5(rdr, kind, start_line, start_column, cljs.core.count(a));
      } else {
        var G__24851 = cljs.core.conj_BANG_.cljs$core$IFn$_invoke$arity$2(a, form);
        a = G__24851;
        continue;
      }
    }

    break;
  }
};
/**
 * Reads and returns a collection ended with delim
 */


cljs.tools.reader.read_delimited = function cljs$tools$reader$read_delimited(kind, delim, rdr, opts, pending_forms) {
  var _STAR_read_delim_STAR__orig_val__24723 = cljs.tools.reader._STAR_read_delim_STAR_;
  var _STAR_read_delim_STAR__temp_val__24724 = true;
  cljs.tools.reader._STAR_read_delim_STAR_ = _STAR_read_delim_STAR__temp_val__24724;

  try {
    return cljs.tools.reader.read_delimited_internal(kind, delim, rdr, opts, pending_forms);
  } finally {
    cljs.tools.reader._STAR_read_delim_STAR_ = _STAR_read_delim_STAR__orig_val__24723;
  }
};
/**
 * Read in a list, including its location if the reader is an indexing reader
 */


cljs.tools.reader.read_list = function cljs$tools$reader$read_list(rdr, _, opts, pending_forms) {
  var vec__24725 = cljs.tools.reader.starting_line_col_info(rdr);
  var start_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24725, 0, null);
  var start_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24725, 1, null);
  var the_list = cljs.tools.reader.read_delimited(new cljs.core.Keyword(null, "list", "list", 765357683), ")", rdr, opts, pending_forms);
  var vec__24728 = cljs.tools.reader.ending_line_col_info(rdr);
  var end_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24728, 0, null);
  var end_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24728, 1, null);
  return cljs.core.with_meta(cljs.core.empty_QMARK_(the_list) ? cljs.core.List.EMPTY : cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.list, the_list), cljs.core.truth_(start_line) ? cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([function () {
    var temp__5804__auto__ = cljs.tools.reader.reader_types.get_file_name(rdr);

    if (cljs.core.truth_(temp__5804__auto__)) {
      var file = temp__5804__auto__;
      return new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "file", "file", -1269645878), file], null);
    } else {
      return null;
    }
  }(), new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "line", "line", 212345235), start_line, new cljs.core.Keyword(null, "column", "column", 2078222095), start_column, new cljs.core.Keyword(null, "end-line", "end-line", 1837326455), end_line, new cljs.core.Keyword(null, "end-column", "end-column", 1425389514), end_column], null)], 0)) : null);
};
/**
 * Read in a vector, including its location if the reader is an indexing reader
 */


cljs.tools.reader.read_vector = function cljs$tools$reader$read_vector(rdr, _, opts, pending_forms) {
  var vec__24731 = cljs.tools.reader.starting_line_col_info(rdr);
  var start_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24731, 0, null);
  var start_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24731, 1, null);
  var the_vector = cljs.tools.reader.read_delimited(new cljs.core.Keyword(null, "vector", "vector", 1902966158), "]", rdr, opts, pending_forms);
  var vec__24734 = cljs.tools.reader.ending_line_col_info(rdr);
  var end_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24734, 0, null);
  var end_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24734, 1, null);
  return cljs.core.with_meta(the_vector, cljs.core.truth_(start_line) ? cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([function () {
    var temp__5804__auto__ = cljs.tools.reader.reader_types.get_file_name(rdr);

    if (cljs.core.truth_(temp__5804__auto__)) {
      var file = temp__5804__auto__;
      return new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "file", "file", -1269645878), file], null);
    } else {
      return null;
    }
  }(), new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "line", "line", 212345235), start_line, new cljs.core.Keyword(null, "column", "column", 2078222095), start_column, new cljs.core.Keyword(null, "end-line", "end-line", 1837326455), end_line, new cljs.core.Keyword(null, "end-column", "end-column", 1425389514), end_column], null)], 0)) : null);
};
/**
 * Read in a map, including its location if the reader is an indexing reader
 */


cljs.tools.reader.read_map = function cljs$tools$reader$read_map(rdr, _, opts, pending_forms) {
  var vec__24737 = cljs.tools.reader.starting_line_col_info(rdr);
  var start_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24737, 0, null);
  var start_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24737, 1, null);
  var the_map = cljs.tools.reader.read_delimited(new cljs.core.Keyword(null, "map", "map", 1371690461), "}", rdr, opts, pending_forms);
  var map_count = cljs.core.count(the_map);
  var ks = cljs.core.take_nth.cljs$core$IFn$_invoke$arity$2(2, the_map);
  var key_set = cljs.core.set(ks);
  var vec__24740 = cljs.tools.reader.ending_line_col_info(rdr);
  var end_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24740, 0, null);
  var end_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24740, 1, null);

  if (cljs.core.odd_QMARK_(map_count)) {
    cljs.tools.reader.impl.errors.throw_odd_map(rdr, start_line, start_column, the_map);
  } else {}

  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(cljs.core.count(key_set), cljs.core.count(ks))) {} else {
    cljs.tools.reader.impl.errors.throw_dup_keys(rdr, new cljs.core.Keyword(null, "map", "map", 1371690461), ks);
  }

  return cljs.core.with_meta(map_count <= 2 * cljs.core.PersistentArrayMap.HASHMAP_THRESHOLD ? cljs.core.PersistentArrayMap.fromArray(cljs.core.to_array(the_map), true, true) : cljs.core.PersistentHashMap.fromArray(cljs.core.to_array(the_map), true), cljs.core.truth_(start_line) ? cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([function () {
    var temp__5804__auto__ = cljs.tools.reader.reader_types.get_file_name(rdr);

    if (cljs.core.truth_(temp__5804__auto__)) {
      var file = temp__5804__auto__;
      return new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "file", "file", -1269645878), file], null);
    } else {
      return null;
    }
  }(), new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "line", "line", 212345235), start_line, new cljs.core.Keyword(null, "column", "column", 2078222095), start_column, new cljs.core.Keyword(null, "end-line", "end-line", 1837326455), end_line, new cljs.core.Keyword(null, "end-column", "end-column", 1425389514), end_column], null)], 0)) : null);
};

cljs.tools.reader.read_number = function cljs$tools$reader$read_number(rdr, initch) {
  var sb = function () {
    var G__24743 = new goog.string.StringBuffer();
    G__24743.append(initch);
    return G__24743;
  }();

  var ch = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

  while (true) {
    if (cljs.core.truth_(function () {
      var or__4126__auto__ = cljs.tools.reader.impl.utils.whitespace_QMARK_(ch);

      if (or__4126__auto__) {
        return or__4126__auto__;
      } else {
        var or__4126__auto____$1 = cljs.tools.reader.macros.cljs$core$IFn$_invoke$arity$1 ? cljs.tools.reader.macros.cljs$core$IFn$_invoke$arity$1(ch) : cljs.tools.reader.macros.call(null, ch);

        if (cljs.core.truth_(or__4126__auto____$1)) {
          return or__4126__auto____$1;
        } else {
          return ch == null;
        }
      }
    }())) {
      var s = cljs.core.str.cljs$core$IFn$_invoke$arity$1(sb);
      rdr.cljs$tools$reader$reader_types$IPushbackReader$unread$arity$2(null, ch);
      var or__4126__auto__ = cljs.tools.reader.impl.commons.match_number(s);

      if (cljs.core.truth_(or__4126__auto__)) {
        return or__4126__auto__;
      } else {
        return cljs.tools.reader.impl.errors.throw_invalid_number(rdr, s);
      }
    } else {
      var G__24852 = function () {
        var G__24744 = sb;
        G__24744.append(ch);
        return G__24744;
      }();

      var G__24853 = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);
      sb = G__24852;
      ch = G__24853;
      continue;
    }

    break;
  }
};

cljs.tools.reader.escape_char = function cljs$tools$reader$escape_char(sb, rdr) {
  var ch = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);
  var G__24745 = ch;

  switch (G__24745) {
    case "t":
      return "\t";
      break;

    case "r":
      return "\r";
      break;

    case "n":
      return "\n";
      break;

    case "\\":
      return "\\";
      break;

    case "\"":
      return "\"";
      break;

    case "b":
      return "\b";
      break;

    case "f":
      return "\f";
      break;

    case "u":
      var ch__$1 = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

      if (-1 === parseInt(ch__$1 | 0, 16)) {
        return cljs.tools.reader.impl.errors.throw_invalid_unicode_escape(rdr, ch__$1);
      } else {
        return cljs.tools.reader.read_unicode_char.cljs$core$IFn$_invoke$arity$5(rdr, ch__$1, 16, 4, true);
      }

      break;

    default:
      if (cljs.tools.reader.impl.utils.numeric_QMARK_(ch)) {
        var ch__$1 = cljs.tools.reader.read_unicode_char.cljs$core$IFn$_invoke$arity$5(rdr, ch, 8, 3, false);

        if ((ch__$1 | 0) > 255) {
          return cljs.tools.reader.impl.errors.throw_bad_octal_number(rdr);
        } else {
          return ch__$1;
        }
      } else {
        return cljs.tools.reader.impl.errors.throw_bad_escape_char(rdr, ch);
      }

  }
};

cljs.tools.reader.read_string_STAR_ = function cljs$tools$reader$read_string_STAR_(reader, _, opts, pending_forms) {
  var sb = new goog.string.StringBuffer();
  var ch = reader.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

  while (true) {
    if (ch == null) {
      return cljs.tools.reader.impl.errors.throw_eof_reading.cljs$core$IFn$_invoke$arity$variadic(reader, new cljs.core.Keyword(null, "string", "string", -1989541586), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2(["\"", sb], 0));
    } else {
      var G__24746 = ch;

      switch (G__24746) {
        case "\\":
          var G__24858 = function () {
            var G__24747 = sb;
            G__24747.append(cljs.tools.reader.escape_char(sb, reader));
            return G__24747;
          }();

          var G__24859 = reader.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);
          sb = G__24858;
          ch = G__24859;
          continue;
          break;

        case "\"":
          return cljs.core.str.cljs$core$IFn$_invoke$arity$1(sb);
          break;

        default:
          var G__24860 = function () {
            var G__24748 = sb;
            G__24748.append(ch);
            return G__24748;
          }();

          var G__24861 = reader.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);
          sb = G__24860;
          ch = G__24861;
          continue;
      }
    }

    break;
  }
};

cljs.tools.reader.loc_info = function cljs$tools$reader$loc_info(rdr, line, column) {
  if (line == null) {
    return null;
  } else {
    var file = cljs.tools.reader.reader_types.get_file_name(rdr);
    var filem = file == null ? null : new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "file", "file", -1269645878), file], null);
    var vec__24749 = cljs.tools.reader.ending_line_col_info(rdr);
    var end_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24749, 0, null);
    var end_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24749, 1, null);
    var lcm = new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "line", "line", 212345235), line, new cljs.core.Keyword(null, "column", "column", 2078222095), column, new cljs.core.Keyword(null, "end-line", "end-line", 1837326455), end_line, new cljs.core.Keyword(null, "end-column", "end-column", 1425389514), end_column], null);
    return cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([filem, lcm], 0));
  }
};

cljs.tools.reader.read_symbol = function cljs$tools$reader$read_symbol(rdr, initch) {
  var vec__24752 = cljs.tools.reader.starting_line_col_info(rdr);
  var line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24752, 0, null);
  var column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24752, 1, null);
  var token = cljs.tools.reader.read_token(rdr, new cljs.core.Keyword(null, "symbol", "symbol", -1038572696), initch);

  if (token == null) {
    return null;
  } else {
    var G__24755 = token;

    switch (G__24755) {
      case "nil":
        return null;
        break;

      case "true":
        return true;
        break;

      case "false":
        return false;
        break;

      case "/":
        return new cljs.core.Symbol(null, "/", "/", -1371932971, null);
        break;

      default:
        var p = cljs.tools.reader.impl.commons.parse_symbol(token);

        if (!(p == null)) {
          var sym = cljs.core.symbol.cljs$core$IFn$_invoke$arity$2(p.cljs$core$IIndexed$_nth$arity$2(null, 0), p.cljs$core$IIndexed$_nth$arity$2(null, 1));
          return sym.cljs$core$IWithMeta$_with_meta$arity$2(null, cljs.tools.reader.loc_info(rdr, line, column));
        } else {
          return cljs.tools.reader.impl.errors.throw_invalid(rdr, new cljs.core.Keyword(null, "symbol", "symbol", -1038572696), token);
        }

    }
  }
};
/**
 * Map from ns alias to ns, if non-nil, it will be used to resolve read-time
 * ns aliases.
 * 
 * Defaults to nil
 */


cljs.tools.reader._STAR_alias_map_STAR_ = null;

cljs.tools.reader.resolve_alias = function cljs$tools$reader$resolve_alias(sym) {
  return cljs.core.get.cljs$core$IFn$_invoke$arity$2(cljs.tools.reader._STAR_alias_map_STAR_, sym);
};

cljs.tools.reader.resolve_ns = function cljs$tools$reader$resolve_ns(sym) {
  var or__4126__auto__ = cljs.tools.reader.resolve_alias(sym);

  if (cljs.core.truth_(or__4126__auto__)) {
    return or__4126__auto__;
  } else {
    var temp__5804__auto__ = cljs.core.find_ns(sym);

    if (cljs.core.truth_(temp__5804__auto__)) {
      var ns = temp__5804__auto__;
      return cljs.core.symbol.cljs$core$IFn$_invoke$arity$1(cljs.core.ns_name(ns));
    } else {
      return null;
    }
  }
};

cljs.tools.reader.read_keyword = function cljs$tools$reader$read_keyword(reader, initch, opts, pending_forms) {
  var ch = reader.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

  if (!cljs.tools.reader.impl.utils.whitespace_QMARK_(ch)) {
    var token = cljs.tools.reader.read_token(reader, new cljs.core.Keyword(null, "keyword", "keyword", 811389747), ch);
    var s = cljs.tools.reader.impl.commons.parse_symbol(token);

    if (!(s == null)) {
      var ns = s.cljs$core$IIndexed$_nth$arity$2(null, 0);
      var name = s.cljs$core$IIndexed$_nth$arity$2(null, 1);

      if (":" === token.charAt(0)) {
        if (!(ns == null)) {
          var temp__5802__auto__ = cljs.tools.reader.resolve_alias(cljs.core.symbol.cljs$core$IFn$_invoke$arity$1(cljs.core.subs.cljs$core$IFn$_invoke$arity$2(ns, 1)));

          if (cljs.core.truth_(temp__5802__auto__)) {
            var ns__$1 = temp__5802__auto__;
            return cljs.core.keyword.cljs$core$IFn$_invoke$arity$2(cljs.core.str.cljs$core$IFn$_invoke$arity$1(ns__$1), name);
          } else {
            return cljs.tools.reader.impl.errors.throw_invalid(reader, new cljs.core.Keyword(null, "keyword", "keyword", 811389747), [":", cljs.core.str.cljs$core$IFn$_invoke$arity$1(token)].join(''));
          }
        } else {
          var temp__5802__auto__ = cljs.core._STAR_ns_STAR_;

          if (cljs.core.truth_(temp__5802__auto__)) {
            var ns__$1 = temp__5802__auto__;
            return cljs.core.keyword.cljs$core$IFn$_invoke$arity$2(cljs.core.str.cljs$core$IFn$_invoke$arity$1(ns__$1), cljs.core.subs.cljs$core$IFn$_invoke$arity$2(name, 1));
          } else {
            return cljs.tools.reader.impl.errors.reader_error.cljs$core$IFn$_invoke$arity$variadic(reader, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2(["Invalid token: :", token], 0));
          }
        }
      } else {
        return cljs.core.keyword.cljs$core$IFn$_invoke$arity$2(ns, name);
      }
    } else {
      return cljs.tools.reader.impl.errors.throw_invalid(reader, new cljs.core.Keyword(null, "keyword", "keyword", 811389747), [":", cljs.core.str.cljs$core$IFn$_invoke$arity$1(token)].join(''));
    }
  } else {
    return cljs.tools.reader.impl.errors.throw_single_colon(reader);
  }
};
/**
 * Returns a function which wraps a reader in a call to sym
 */


cljs.tools.reader.wrapping_reader = function cljs$tools$reader$wrapping_reader(sym) {
  return function (rdr, _, opts, pending_forms) {
    return new cljs.core.List(null, sym, new cljs.core.List(null, cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms), null, 1, null), 2, null);
  };
};
/**
 * Read metadata and return the following object with the metadata applied
 */


cljs.tools.reader.read_meta = function cljs$tools$reader$read_meta(rdr, _, opts, pending_forms) {
  if (cljs.tools.reader.reader_types.source_logging_reader_QMARK_(rdr) && !cljs.tools.reader.impl.utils.whitespace_QMARK_(cljs.tools.reader.reader_types.peek_char(rdr))) {
    return cljs.tools.reader.reader_types.log_source_STAR_(rdr, function () {
      var vec__24756 = cljs.tools.reader.starting_line_col_info(rdr);
      var line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24756, 0, null);
      var column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24756, 1, null);
      var m = cljs.tools.reader.impl.utils.desugar_meta(cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms));

      if (cljs.core.map_QMARK_(m)) {} else {
        cljs.tools.reader.impl.errors.throw_bad_metadata(rdr, m);
      }

      var o = cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms);

      if (!(o == null) ? o.cljs$lang$protocol_mask$partition0$ & 131072 || cljs.core.PROTOCOL_SENTINEL === o.cljs$core$IMeta$ ? true : false : false) {
        var m__$1 = cljs.core.truth_(function () {
          var and__4115__auto__ = line;

          if (cljs.core.truth_(and__4115__auto__)) {
            return cljs.core.seq_QMARK_(o);
          } else {
            return and__4115__auto__;
          }
        }()) ? cljs.core.assoc.cljs$core$IFn$_invoke$arity$variadic(m, new cljs.core.Keyword(null, "line", "line", 212345235), line, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword(null, "column", "column", 2078222095), column], 0)) : m;

        if (!(o == null) ? o.cljs$lang$protocol_mask$partition0$ & 262144 || cljs.core.PROTOCOL_SENTINEL === o.cljs$core$IWithMeta$ ? true : false : false) {
          return cljs.core.with_meta(o, cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([cljs.core.meta(o), m__$1], 0)));
        } else {
          return cljs.core.reset_meta_BANG_(o, m__$1);
        }
      } else {
        return cljs.tools.reader.impl.errors.throw_bad_metadata_target(rdr, o);
      }
    });
  } else {
    var vec__24761 = cljs.tools.reader.starting_line_col_info(rdr);
    var line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24761, 0, null);
    var column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24761, 1, null);
    var m = cljs.tools.reader.impl.utils.desugar_meta(cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms));

    if (cljs.core.map_QMARK_(m)) {} else {
      cljs.tools.reader.impl.errors.throw_bad_metadata(rdr, m);
    }

    var o = cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms);

    if (!(o == null) ? o.cljs$lang$protocol_mask$partition0$ & 131072 || cljs.core.PROTOCOL_SENTINEL === o.cljs$core$IMeta$ ? true : false : false) {
      var m__$1 = cljs.core.truth_(function () {
        var and__4115__auto__ = line;

        if (cljs.core.truth_(and__4115__auto__)) {
          return cljs.core.seq_QMARK_(o);
        } else {
          return and__4115__auto__;
        }
      }()) ? cljs.core.assoc.cljs$core$IFn$_invoke$arity$variadic(m, new cljs.core.Keyword(null, "line", "line", 212345235), line, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword(null, "column", "column", 2078222095), column], 0)) : m;

      if (!(o == null) ? o.cljs$lang$protocol_mask$partition0$ & 262144 || cljs.core.PROTOCOL_SENTINEL === o.cljs$core$IWithMeta$ ? true : false : false) {
        return cljs.core.with_meta(o, cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([cljs.core.meta(o), m__$1], 0)));
      } else {
        return cljs.core.reset_meta_BANG_(o, m__$1);
      }
    } else {
      return cljs.tools.reader.impl.errors.throw_bad_metadata_target(rdr, o);
    }
  }
};

cljs.tools.reader.read_set = function cljs$tools$reader$read_set(rdr, _, opts, pending_forms) {
  var vec__24766 = cljs.tools.reader.starting_line_col_info(rdr);
  var start_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24766, 0, null);
  var start_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24766, 1, null);
  var start_column__$1 = cljs.core.truth_(start_column) ? start_column - 1 | 0 : null;
  var coll = cljs.tools.reader.read_delimited(new cljs.core.Keyword(null, "set", "set", 304602554), "}", rdr, opts, pending_forms);
  var the_set = cljs.core.set(coll);
  var vec__24769 = cljs.tools.reader.ending_line_col_info(rdr);
  var end_line = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24769, 0, null);
  var end_column = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24769, 1, null);

  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(cljs.core.count(coll), cljs.core.count(the_set))) {} else {
    cljs.tools.reader.impl.errors.reader_error.cljs$core$IFn$_invoke$arity$variadic(rdr, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([cljs.tools.reader.impl.errors.throw_dup_keys(rdr, new cljs.core.Keyword(null, "set", "set", 304602554), coll)], 0));
  }

  return cljs.core.with_meta(the_set, cljs.core.truth_(start_line) ? cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([function () {
    var temp__5804__auto__ = cljs.tools.reader.reader_types.get_file_name(rdr);

    if (cljs.core.truth_(temp__5804__auto__)) {
      var file = temp__5804__auto__;
      return new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "file", "file", -1269645878), file], null);
    } else {
      return null;
    }
  }(), new cljs.core.PersistentArrayMap(null, 4, [new cljs.core.Keyword(null, "line", "line", 212345235), start_line, new cljs.core.Keyword(null, "column", "column", 2078222095), start_column__$1, new cljs.core.Keyword(null, "end-line", "end-line", 1837326455), end_line, new cljs.core.Keyword(null, "end-column", "end-column", 1425389514), end_column], null)], 0)) : null);
};
/**
 * Read and discard the first object from rdr
 */


cljs.tools.reader.read_discard = function cljs$tools$reader$read_discard(rdr, _, opts, pending_forms) {
  var G__24772 = rdr;
  cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(G__24772, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, G__24772, true, null, opts, pending_forms);
  return G__24772;
};

cljs.tools.reader.read_symbolic_value = function cljs$tools$reader$read_symbolic_value(rdr, _, opts, pending_forms) {
  var sym = cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms);
  var G__24773 = sym;

  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Symbol(null, "NaN", "NaN", 666918153, null), G__24773)) {
    return Number.NaN;
  } else {
    if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Symbol(null, "-Inf", "-Inf", -2123243689, null), G__24773)) {
      return Number.NEGATIVE_INFINITY;
    } else {
      if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Symbol(null, "Inf", "Inf", 647172781, null), G__24773)) {
        return Number.POSITIVE_INFINITY;
      } else {
        return cljs.tools.reader.impl.errors.reader_error.cljs$core$IFn$_invoke$arity$variadic(rdr, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([["Invalid token: ##", cljs.core.str.cljs$core$IFn$_invoke$arity$1(sym)].join('')], 0));
      }
    }
  }
};

cljs.tools.reader.RESERVED_FEATURES = new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "else", "else", -1508377146), null, new cljs.core.Keyword(null, "none", "none", 1333468478), null], null), null);

cljs.tools.reader.has_feature_QMARK_ = function cljs$tools$reader$has_feature_QMARK_(rdr, feature, opts) {
  if (feature instanceof cljs.core.Keyword) {
    return cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword(null, "default", "default", -1987822328), feature) || cljs.core.contains_QMARK_(cljs.core.get.cljs$core$IFn$_invoke$arity$2(opts, new cljs.core.Keyword(null, "features", "features", -1146962336)), feature);
  } else {
    return cljs.tools.reader.impl.errors.reader_error.cljs$core$IFn$_invoke$arity$variadic(rdr, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2(["Feature should be a keyword: ", feature], 0));
  }
};

cljs.tools.reader.check_eof_error = function cljs$tools$reader$check_eof_error(form, rdr, first_line) {
  if (form === cljs.tools.reader.READ_EOF) {
    return cljs.tools.reader.impl.errors.throw_eof_error(rdr, first_line < 0 ? first_line : false);
  } else {
    return null;
  }
};

cljs.tools.reader.check_reserved_features = function cljs$tools$reader$check_reserved_features(rdr, form) {
  if (cljs.core.truth_(cljs.core.get.cljs$core$IFn$_invoke$arity$2(cljs.tools.reader.RESERVED_FEATURES, form))) {
    return cljs.tools.reader.impl.errors.reader_error.cljs$core$IFn$_invoke$arity$variadic(rdr, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2(["Feature name ", form, " is reserved"], 0));
  } else {
    return null;
  }
};

cljs.tools.reader.check_invalid_read_cond = function cljs$tools$reader$check_invalid_read_cond(form, rdr, first_line) {
  if (form === cljs.tools.reader.READ_FINISHED) {
    if (first_line < 0) {
      return cljs.tools.reader.impl.errors.reader_error.cljs$core$IFn$_invoke$arity$variadic(rdr, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2(["read-cond requires an even number of forms"], 0));
    } else {
      return cljs.tools.reader.impl.errors.reader_error.cljs$core$IFn$_invoke$arity$variadic(rdr, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2(["read-cond starting on line ", first_line, " requires an even number of forms"], 0));
    }
  } else {
    return null;
  }
};
/**
 * Read next form and suppress. Return nil or READ_FINISHED.
 */


cljs.tools.reader.read_suppress = function cljs$tools$reader$read_suppress(first_line, rdr, opts, pending_forms) {
  var _STAR_suppress_read_STAR__orig_val__24774 = cljs.tools.reader._STAR_suppress_read_STAR_;
  var _STAR_suppress_read_STAR__temp_val__24775 = true;
  cljs.tools.reader._STAR_suppress_read_STAR_ = _STAR_suppress_read_STAR__temp_val__24775;

  try {
    var form = function () {
      var G__24776 = rdr;
      var G__24777 = false;
      var G__24778 = cljs.tools.reader.READ_EOF;
      var G__24779 = ")";
      var G__24780 = opts;
      var G__24781 = pending_forms;
      return cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6(G__24776, G__24777, G__24778, G__24779, G__24780, G__24781) : cljs.tools.reader.read_STAR_.call(null, G__24776, G__24777, G__24778, G__24779, G__24780, G__24781);
    }();

    cljs.tools.reader.check_eof_error(form, rdr, first_line);

    if (form === cljs.tools.reader.READ_FINISHED) {
      return cljs.tools.reader.READ_FINISHED;
    } else {
      return null;
    }
  } finally {
    cljs.tools.reader._STAR_suppress_read_STAR_ = _STAR_suppress_read_STAR__orig_val__24774;
  }
};

if (typeof cljs !== 'undefined' && typeof cljs.tools !== 'undefined' && typeof cljs.tools.reader !== 'undefined' && typeof cljs.tools.reader.NO_MATCH !== 'undefined') {} else {
  cljs.tools.reader.NO_MATCH = new Object();
}
/**
 * Read next feature. If matched, read next form and return.
 * Otherwise, read and skip next form, returning READ_FINISHED or nil.
 */


cljs.tools.reader.match_feature = function cljs$tools$reader$match_feature(first_line, rdr, opts, pending_forms) {
  var feature = function () {
    var G__24782 = rdr;
    var G__24783 = false;
    var G__24784 = cljs.tools.reader.READ_EOF;
    var G__24785 = ")";
    var G__24786 = opts;
    var G__24787 = pending_forms;
    return cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6(G__24782, G__24783, G__24784, G__24785, G__24786, G__24787) : cljs.tools.reader.read_STAR_.call(null, G__24782, G__24783, G__24784, G__24785, G__24786, G__24787);
  }();

  cljs.tools.reader.check_eof_error(feature, rdr, first_line);

  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(feature, cljs.tools.reader.READ_FINISHED)) {
    return cljs.tools.reader.READ_FINISHED;
  } else {
    cljs.tools.reader.check_reserved_features(rdr, feature);

    if (cljs.tools.reader.has_feature_QMARK_(rdr, feature, opts)) {
      var G__24788 = function () {
        var G__24789 = rdr;
        var G__24790 = false;
        var G__24791 = cljs.tools.reader.READ_EOF;
        var G__24792 = ")";
        var G__24793 = opts;
        var G__24794 = pending_forms;
        return cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6(G__24789, G__24790, G__24791, G__24792, G__24793, G__24794) : cljs.tools.reader.read_STAR_.call(null, G__24789, G__24790, G__24791, G__24792, G__24793, G__24794);
      }();

      cljs.tools.reader.check_eof_error(G__24788, rdr, first_line);
      cljs.tools.reader.check_invalid_read_cond(G__24788, rdr, first_line);
      return G__24788;
    } else {
      var or__4126__auto__ = cljs.tools.reader.read_suppress(first_line, rdr, opts, pending_forms);

      if (cljs.core.truth_(or__4126__auto__)) {
        return or__4126__auto__;
      } else {
        return cljs.tools.reader.NO_MATCH;
      }
    }
  }
};

cljs.tools.reader.read_cond_delimited = function cljs$tools$reader$read_cond_delimited(rdr, splicing, opts, pending_forms) {
  var first_line = cljs.tools.reader.reader_types.indexing_reader_QMARK_(rdr) ? cljs.tools.reader.reader_types.get_line_number(rdr) : -1;

  var result = function () {
    var matched = cljs.tools.reader.NO_MATCH;
    var finished = null;

    while (true) {
      if (matched === cljs.tools.reader.NO_MATCH) {
        var match = cljs.tools.reader.match_feature(first_line, rdr, opts, pending_forms);

        if (match === cljs.tools.reader.READ_FINISHED) {
          return cljs.tools.reader.READ_FINISHED;
        } else {
          var G__24880 = match;
          var G__24881 = null;
          matched = G__24880;
          finished = G__24881;
          continue;
        }
      } else {
        if (!(finished === cljs.tools.reader.READ_FINISHED)) {
          var G__24882 = matched;
          var G__24883 = cljs.tools.reader.read_suppress(first_line, rdr, opts, pending_forms);
          matched = G__24882;
          finished = G__24883;
          continue;
        } else {
          return matched;
        }
      }

      break;
    }
  }();

  if (result === cljs.tools.reader.READ_FINISHED) {
    return rdr;
  } else {
    if (cljs.core.truth_(splicing)) {
      if (!(result == null) ? result.cljs$lang$protocol_mask$partition0$ & 16777216 || cljs.core.PROTOCOL_SENTINEL === result.cljs$core$ISequential$ ? true : false : false) {
        goog.array.insertArrayAt(pending_forms, cljs.core.to_array(result), 0);
        return rdr;
      } else {
        return cljs.tools.reader.impl.errors.reader_error.cljs$core$IFn$_invoke$arity$variadic(rdr, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2(["Spliced form list in read-cond-splicing must implement ISequential"], 0));
      }
    } else {
      return result;
    }
  }
};

cljs.tools.reader.read_cond = function cljs$tools$reader$read_cond(rdr, _, opts, pending_forms) {
  if (cljs.core.not(function () {
    var and__4115__auto__ = opts;

    if (cljs.core.truth_(and__4115__auto__)) {
      var G__24797 = new cljs.core.Keyword(null, "read-cond", "read-cond", 1056899244).cljs$core$IFn$_invoke$arity$1(opts);
      var fexpr__24796 = new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "preserve", "preserve", 1276846509), null, new cljs.core.Keyword(null, "allow", "allow", -1857325745), null], null), null);
      return fexpr__24796.cljs$core$IFn$_invoke$arity$1 ? fexpr__24796.cljs$core$IFn$_invoke$arity$1(G__24797) : fexpr__24796.call(null, G__24797);
    } else {
      return and__4115__auto__;
    }
  }())) {
    throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("Conditional read not allowed", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "runtime-exception", "runtime-exception", -1495664514)], null));
  } else {}

  var temp__5802__auto__ = rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

  if (cljs.core.truth_(temp__5802__auto__)) {
    var ch = temp__5802__auto__;

    var splicing = cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(ch, "@");

    var ch__$1 = splicing ? rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null) : ch;

    if (splicing) {
      if (cljs.core.truth_(cljs.tools.reader._STAR_read_delim_STAR_)) {} else {
        cljs.tools.reader.impl.errors.reader_error.cljs$core$IFn$_invoke$arity$variadic(rdr, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2(["cond-splice not in list"], 0));
      }
    } else {}

    var temp__5802__auto____$1 = cljs.tools.reader.impl.utils.whitespace_QMARK_(ch__$1) ? cljs.tools.reader.impl.commons.read_past(cljs.tools.reader.impl.utils.whitespace_QMARK_, rdr) : ch__$1;

    if (cljs.core.truth_(temp__5802__auto____$1)) {
      var ch__$2 = temp__5802__auto____$1;

      if (cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(ch__$2, "(")) {
        throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("read-cond body must be a list", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "runtime-exception", "runtime-exception", -1495664514)], null));
      } else {
        var _STAR_suppress_read_STAR__orig_val__24798 = cljs.tools.reader._STAR_suppress_read_STAR_;

        var _STAR_suppress_read_STAR__temp_val__24799 = function () {
          var or__4126__auto__ = cljs.tools.reader._STAR_suppress_read_STAR_;

          if (cljs.core.truth_(or__4126__auto__)) {
            return or__4126__auto__;
          } else {
            return cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword(null, "preserve", "preserve", 1276846509), new cljs.core.Keyword(null, "read-cond", "read-cond", 1056899244).cljs$core$IFn$_invoke$arity$1(opts));
          }
        }();

        cljs.tools.reader._STAR_suppress_read_STAR_ = _STAR_suppress_read_STAR__temp_val__24799;

        try {
          if (cljs.core.truth_(cljs.tools.reader._STAR_suppress_read_STAR_)) {
            return cljs.tools.reader.impl.utils.reader_conditional(cljs.tools.reader.read_list(rdr, ch__$2, opts, pending_forms), splicing);
          } else {
            return cljs.tools.reader.read_cond_delimited(rdr, splicing, opts, pending_forms);
          }
        } finally {
          cljs.tools.reader._STAR_suppress_read_STAR_ = _STAR_suppress_read_STAR__orig_val__24798;
        }
      }
    } else {
      return cljs.tools.reader.impl.errors.throw_eof_in_character(rdr);
    }
  } else {
    return cljs.tools.reader.impl.errors.throw_eof_in_character(rdr);
  }
};

cljs.tools.reader.arg_env = null;
/**
 * Get a symbol for an anonymous ?argument?
 */

cljs.tools.reader.garg = function cljs$tools$reader$garg(n) {
  return cljs.core.symbol.cljs$core$IFn$_invoke$arity$1([-1 === n ? "rest" : ["p", cljs.core.str.cljs$core$IFn$_invoke$arity$1(n)].join(''), "__", cljs.core.str.cljs$core$IFn$_invoke$arity$1(cljs.tools.reader.impl.utils.next_id()), "#"].join(''));
};

cljs.tools.reader.read_fn = function cljs$tools$reader$read_fn(rdr, _, opts, pending_forms) {
  if (cljs.core.truth_(cljs.tools.reader.arg_env)) {
    throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("Nested #()s are not allowed", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "illegal-state", "illegal-state", -1519851182)], null));
  } else {}

  var arg_env_orig_val__24800 = cljs.tools.reader.arg_env;
  var arg_env_temp_val__24801 = cljs.core.sorted_map();
  cljs.tools.reader.arg_env = arg_env_temp_val__24801;

  try {
    var form = function () {
      var G__24802 = function () {
        var G__24807 = rdr;
        cljs.tools.reader.reader_types.unread(G__24807, "(");
        return G__24807;
      }();

      var G__24803 = true;
      var G__24804 = null;
      var G__24805 = opts;
      var G__24806 = pending_forms;
      return cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(G__24802, G__24803, G__24804, G__24805, G__24806) : cljs.tools.reader.read_STAR_.call(null, G__24802, G__24803, G__24804, G__24805, G__24806);
    }();

    var rargs = cljs.core.rseq(cljs.tools.reader.arg_env);
    var args = rargs ? function () {
      var higharg = cljs.core.key(cljs.core.first(rargs));

      var args = function () {
        var i = 1;
        var args = cljs.core.transient$(cljs.core.PersistentVector.EMPTY);

        while (true) {
          if (i > higharg) {
            return cljs.core.persistent_BANG_(args);
          } else {
            var G__24885 = i + 1;
            var G__24886 = cljs.core.conj_BANG_.cljs$core$IFn$_invoke$arity$2(args, function () {
              var or__4126__auto__ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(cljs.tools.reader.arg_env, i);

              if (cljs.core.truth_(or__4126__auto__)) {
                return or__4126__auto__;
              } else {
                return cljs.tools.reader.garg(i);
              }
            }());
            i = G__24885;
            args = G__24886;
            continue;
          }

          break;
        }
      }();

      var args__$1 = cljs.core.truth_(cljs.tools.reader.arg_env.call(null, -1)) ? cljs.core.conj.cljs$core$IFn$_invoke$arity$variadic(args, new cljs.core.Symbol(null, "&", "&", -2144855648, null), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([cljs.tools.reader.arg_env.call(null, -1)], 0)) : args;
      return args__$1;
    }() : cljs.core.PersistentVector.EMPTY;
    return new cljs.core.List(null, new cljs.core.Symbol(null, "fn*", "fn*", -752876845, null), new cljs.core.List(null, args, new cljs.core.List(null, form, null, 1, null), 2, null), 3, null);
  } finally {
    cljs.tools.reader.arg_env = arg_env_orig_val__24800;
  }
};
/**
 * Registers an argument to the arg-env
 */


cljs.tools.reader.register_arg = function cljs$tools$reader$register_arg(n) {
  if (cljs.core.truth_(cljs.tools.reader.arg_env)) {
    var temp__5802__auto__ = cljs.tools.reader.arg_env.call(null, n);

    if (cljs.core.truth_(temp__5802__auto__)) {
      var ret = temp__5802__auto__;
      return ret;
    } else {
      var g = cljs.tools.reader.garg(n);
      cljs.tools.reader.arg_env = cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(cljs.tools.reader.arg_env, n, g);
      return g;
    }
  } else {
    throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("Arg literal not in #()", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "illegal-state", "illegal-state", -1519851182)], null));
  }
};

cljs.tools.reader.read_arg = function cljs$tools$reader$read_arg(rdr, pct, opts, pending_forms) {
  if (cljs.tools.reader.arg_env == null) {
    return cljs.tools.reader.read_symbol(rdr, pct);
  } else {
    var ch = rdr.cljs$tools$reader$reader_types$Reader$peek_char$arity$1(null);

    if (cljs.tools.reader.impl.utils.whitespace_QMARK_(ch) || cljs.tools.reader.macro_terminating_QMARK_(ch) || ch == null) {
      return cljs.tools.reader.register_arg(1);
    } else {
      if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(ch, "&")) {
        rdr.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);
        return cljs.tools.reader.register_arg(-1);
      } else {
        var n = cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms);

        if (!cljs.core.integer_QMARK_(n)) {
          throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("Arg literal must be %, %& or %integer", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "illegal-state", "illegal-state", -1519851182)], null));
        } else {
          return cljs.tools.reader.register_arg(n);
        }
      }
    }
  }
};

cljs.tools.reader.gensym_env = null;

cljs.tools.reader.read_unquote = function cljs$tools$reader$read_unquote(rdr, comma, opts, pending_forms) {
  var temp__5802__auto__ = rdr.cljs$tools$reader$reader_types$Reader$peek_char$arity$1(null);

  if (cljs.core.truth_(temp__5802__auto__)) {
    var ch = temp__5802__auto__;

    if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2("@", ch)) {
      return cljs.tools.reader.wrapping_reader(new cljs.core.Symbol("clojure.core", "unquote-splicing", "clojure.core/unquote-splicing", -552003150, null))(function () {
        var G__24808 = rdr;
        G__24808.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);
        return G__24808;
      }(), "@", opts, pending_forms);
    } else {
      return cljs.tools.reader.wrapping_reader(new cljs.core.Symbol("clojure.core", "unquote", "clojure.core/unquote", 843087510, null))(rdr, "~", opts, pending_forms);
    }
  } else {
    return null;
  }
};

cljs.tools.reader.unquote_splicing_QMARK_ = function cljs$tools$reader$unquote_splicing_QMARK_(form) {
  return cljs.core.seq_QMARK_(form) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(cljs.core.first(form), new cljs.core.Symbol("clojure.core", "unquote-splicing", "clojure.core/unquote-splicing", -552003150, null));
};

cljs.tools.reader.unquote_QMARK_ = function cljs$tools$reader$unquote_QMARK_(form) {
  return cljs.core.seq_QMARK_(form) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(cljs.core.first(form), new cljs.core.Symbol("clojure.core", "unquote", "clojure.core/unquote", 843087510, null));
};
/**
 * Expand a list by resolving its syntax quotes and unquotes
 */


cljs.tools.reader.expand_list = function cljs$tools$reader$expand_list(s) {
  var s__$1 = cljs.core.seq(s);
  var r = cljs.core.transient$(cljs.core.PersistentVector.EMPTY);

  while (true) {
    if (s__$1) {
      var item = cljs.core.first(s__$1);
      var ret = cljs.core.conj_BANG_.cljs$core$IFn$_invoke$arity$2(r, cljs.tools.reader.unquote_QMARK_(item) ? new cljs.core.List(null, new cljs.core.Symbol("clojure.core", "list", "clojure.core/list", -1119203325, null), new cljs.core.List(null, cljs.core.second(item), null, 1, null), 2, null) : cljs.tools.reader.unquote_splicing_QMARK_(item) ? cljs.core.second(item) : new cljs.core.List(null, new cljs.core.Symbol("clojure.core", "list", "clojure.core/list", -1119203325, null), new cljs.core.List(null, cljs.tools.reader.syntax_quote_STAR_.cljs$core$IFn$_invoke$arity$1 ? cljs.tools.reader.syntax_quote_STAR_.cljs$core$IFn$_invoke$arity$1(item) : cljs.tools.reader.syntax_quote_STAR_.call(null, item), null, 1, null), 2, null));
      var G__24887 = cljs.core.next(s__$1);
      var G__24888 = ret;
      s__$1 = G__24887;
      r = G__24888;
      continue;
    } else {
      return cljs.core.seq(cljs.core.persistent_BANG_(r));
    }

    break;
  }
};
/**
 * Flatten a map into a seq of alternate keys and values
 */


cljs.tools.reader.flatten_map = function cljs$tools$reader$flatten_map(form) {
  var s = cljs.core.seq(form);
  var key_vals = cljs.core.transient$(cljs.core.PersistentVector.EMPTY);

  while (true) {
    if (s) {
      var e = cljs.core.first(s);
      var G__24889 = cljs.core.next(s);
      var G__24890 = cljs.core.conj_BANG_.cljs$core$IFn$_invoke$arity$2(cljs.core.conj_BANG_.cljs$core$IFn$_invoke$arity$2(key_vals, cljs.core.key(e)), cljs.core.val(e));
      s = G__24889;
      key_vals = G__24890;
      continue;
    } else {
      return cljs.core.seq(cljs.core.persistent_BANG_(key_vals));
    }

    break;
  }
};

cljs.tools.reader.register_gensym = function cljs$tools$reader$register_gensym(sym) {
  if (cljs.core.not(cljs.tools.reader.gensym_env)) {
    throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("Gensym literal not in syntax-quote", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "illegal-state", "illegal-state", -1519851182)], null));
  } else {}

  var or__4126__auto__ = cljs.core.get.cljs$core$IFn$_invoke$arity$2(cljs.tools.reader.gensym_env, sym);

  if (cljs.core.truth_(or__4126__auto__)) {
    return or__4126__auto__;
  } else {
    var gs = cljs.core.symbol.cljs$core$IFn$_invoke$arity$1([cljs.core.subs.cljs$core$IFn$_invoke$arity$3(cljs.core.name(sym), 0, cljs.core.name(sym).length - 1), "__", cljs.core.str.cljs$core$IFn$_invoke$arity$1(cljs.tools.reader.impl.utils.next_id()), "__auto__"].join(''));
    cljs.tools.reader.gensym_env = cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(cljs.tools.reader.gensym_env, sym, gs);
    return gs;
  }
};

cljs.tools.reader.add_meta = function cljs$tools$reader$add_meta(form, ret) {
  if ((!(form == null) ? form.cljs$lang$protocol_mask$partition0$ & 262144 || cljs.core.PROTOCOL_SENTINEL === form.cljs$core$IWithMeta$ ? true : false : false) ? cljs.core.seq(cljs.core.dissoc.cljs$core$IFn$_invoke$arity$variadic(cljs.core.meta(form), new cljs.core.Keyword(null, "line", "line", 212345235), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.Keyword(null, "column", "column", 2078222095), new cljs.core.Keyword(null, "end-line", "end-line", 1837326455), new cljs.core.Keyword(null, "end-column", "end-column", 1425389514), new cljs.core.Keyword(null, "file", "file", -1269645878), new cljs.core.Keyword(null, "source", "source", -433931539)], 0))) : false) {
    return new cljs.core.List(null, new cljs.core.Symbol("cljs.core", "with-meta", "cljs.core/with-meta", 749126446, null), new cljs.core.List(null, ret, new cljs.core.List(null, function () {
      var G__24812 = cljs.core.meta(form);
      return cljs.tools.reader.syntax_quote_STAR_.cljs$core$IFn$_invoke$arity$1 ? cljs.tools.reader.syntax_quote_STAR_.cljs$core$IFn$_invoke$arity$1(G__24812) : cljs.tools.reader.syntax_quote_STAR_.call(null, G__24812);
    }(), null, 1, null), 2, null), 3, null);
  } else {
    return ret;
  }
};

cljs.tools.reader.syntax_quote_coll = function cljs$tools$reader$syntax_quote_coll(type, coll) {
  var res = new cljs.core.List(null, new cljs.core.Symbol("cljs.core", "sequence", "cljs.core/sequence", 1908459032, null), new cljs.core.List(null, cljs.core.cons(new cljs.core.Symbol("cljs.core", "concat", "cljs.core/concat", -1133584918, null), cljs.tools.reader.expand_list(coll)), null, 1, null), 2, null);

  if (cljs.core.truth_(type)) {
    return new cljs.core.List(null, new cljs.core.Symbol("cljs.core", "apply", "cljs.core/apply", 1757277831, null), new cljs.core.List(null, type, new cljs.core.List(null, res, null, 1, null), 2, null), 3, null);
  } else {
    return res;
  }
};
/**
 * Decide which map type to use, array-map if less than 16 elements
 */


cljs.tools.reader.map_func = function cljs$tools$reader$map_func(coll) {
  if (cljs.core.count(coll) >= 16) {
    return new cljs.core.Symbol("cljs.core", "hash-map", "cljs.core/hash-map", 303385767, null);
  } else {
    return new cljs.core.Symbol("cljs.core", "array-map", "cljs.core/array-map", -1519210683, null);
  }
};

cljs.tools.reader.bool_QMARK_ = function cljs$tools$reader$bool_QMARK_(x) {
  return x instanceof Boolean || x === true || x === false;
};
/**
 * Resolve a symbol s into its fully qualified namespace version
 */


cljs.tools.reader.resolve_symbol = function cljs$tools$reader$resolve_symbol(s) {
  throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("resolve-symbol is not implemented", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "sym", "sym", -1444860305), s], null));
};

cljs.tools.reader.syntax_quote_STAR_ = function cljs$tools$reader$syntax_quote_STAR_(form) {
  return cljs.tools.reader.add_meta(form, cljs.core.special_symbol_QMARK_(form) ? new cljs.core.List(null, new cljs.core.Symbol(null, "quote", "quote", 1377916282, null), new cljs.core.List(null, form, null, 1, null), 2, null) : form instanceof cljs.core.Symbol ? new cljs.core.List(null, new cljs.core.Symbol(null, "quote", "quote", 1377916282, null), new cljs.core.List(null, cljs.core.truth_(cljs.core.not(cljs.core.namespace(form)) ? goog.string.endsWith(cljs.core.name(form), "#") : false) ? cljs.tools.reader.register_gensym(form) : function () {
    var sym = cljs.core.str.cljs$core$IFn$_invoke$arity$1(form);

    if (cljs.core.truth_(goog.string.endsWith(sym, "."))) {
      var csym = cljs.core.symbol.cljs$core$IFn$_invoke$arity$1(cljs.core.subs.cljs$core$IFn$_invoke$arity$3(sym, 0, sym.length - 1));
      return cljs.core.symbol.cljs$core$IFn$_invoke$arity$1([cljs.core.str.cljs$core$IFn$_invoke$arity$1(cljs.tools.reader.resolve_symbol.call(null, csym)), "."].join(''));
    } else {
      return cljs.tools.reader.resolve_symbol.call(null, form);
    }
  }(), null, 1, null), 2, null) : cljs.tools.reader.unquote_QMARK_(form) ? cljs.core.second(form) : cljs.tools.reader.unquote_splicing_QMARK_(form) ? function () {
    throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("unquote-splice not in list", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "illegal-state", "illegal-state", -1519851182)], null));
  }() : cljs.core.coll_QMARK_(form) ? (!(form == null) ? form.cljs$lang$protocol_mask$partition0$ & 67108864 || cljs.core.PROTOCOL_SENTINEL === form.cljs$core$IRecord$ ? true : false : false) ? form : cljs.core.map_QMARK_(form) ? cljs.tools.reader.syntax_quote_coll(cljs.tools.reader.map_func(form), cljs.tools.reader.flatten_map(form)) : cljs.core.vector_QMARK_(form) ? new cljs.core.List(null, new cljs.core.Symbol("cljs.core", "vec", "cljs.core/vec", 307622519, null), new cljs.core.List(null, cljs.tools.reader.syntax_quote_coll(null, form), null, 1, null), 2, null) : cljs.core.set_QMARK_(form) ? cljs.tools.reader.syntax_quote_coll(new cljs.core.Symbol("cljs.core", "hash-set", "cljs.core/hash-set", 1130426749, null), form) : cljs.core.seq_QMARK_(form) || cljs.core.list_QMARK_(form) ? function () {
    var seq = cljs.core.seq(form);

    if (seq) {
      return cljs.tools.reader.syntax_quote_coll(null, seq);
    } else {
      return cljs.core.list(new cljs.core.Symbol("cljs.core", "list", "cljs.core/list", -1331406371, null));
    }
  }() : function () {
    throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("Unknown Collection type", new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "unsupported-operation", "unsupported-operation", 1890540953)], null));
  }() : form instanceof cljs.core.Keyword || typeof form === 'number' || typeof form === 'string' || form == null || cljs.tools.reader.bool_QMARK_(form) || form instanceof RegExp ? form : new cljs.core.List(null, new cljs.core.Symbol(null, "quote", "quote", 1377916282, null), new cljs.core.List(null, form, null, 1, null), 2, null));
};

cljs.tools.reader.read_syntax_quote = function cljs$tools$reader$read_syntax_quote(rdr, backquote, opts, pending_forms) {
  var gensym_env_orig_val__24814 = cljs.tools.reader.gensym_env;
  var gensym_env_temp_val__24815 = cljs.core.PersistentArrayMap.EMPTY;
  cljs.tools.reader.gensym_env = gensym_env_temp_val__24815;

  try {
    return cljs.tools.reader.syntax_quote_STAR_(cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms));
  } finally {
    cljs.tools.reader.gensym_env = gensym_env_orig_val__24814;
  }
};

cljs.tools.reader.read_namespaced_map = function cljs$tools$reader$read_namespaced_map(rdr, _, opts, pending_forms) {
  var token = cljs.tools.reader.read_token(rdr, new cljs.core.Keyword(null, "namespaced-map", "namespaced-map", 1235665380), cljs.tools.reader.reader_types.read_char(rdr));
  var temp__5802__auto__ = cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(token, ":") ? cljs.core.ns_name(cljs.core._STAR_ns_STAR_) : cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(":", cljs.core.first(token)) ? function () {
    var G__24816 = token;
    var G__24816__$1 = G__24816 == null ? null : cljs.core.subs.cljs$core$IFn$_invoke$arity$2(G__24816, 1);
    var G__24816__$2 = G__24816__$1 == null ? null : cljs.tools.reader.impl.commons.parse_symbol(G__24816__$1);
    var G__24816__$3 = G__24816__$2 == null ? null : cljs.tools.reader.impl.utils.second_SINGLEQUOTE_(G__24816__$2);
    var G__24816__$4 = G__24816__$3 == null ? null : cljs.core.symbol.cljs$core$IFn$_invoke$arity$1(G__24816__$3);

    if (G__24816__$4 == null) {
      return null;
    } else {
      return cljs.tools.reader.resolve_ns(G__24816__$4);
    }
  }() : function () {
    var G__24817 = token;
    var G__24817__$1 = G__24817 == null ? null : cljs.tools.reader.impl.commons.parse_symbol(G__24817);

    if (G__24817__$1 == null) {
      return null;
    } else {
      return cljs.tools.reader.impl.utils.second_SINGLEQUOTE_(G__24817__$1);
    }
  }();

  if (cljs.core.truth_(temp__5802__auto__)) {
    var ns = temp__5802__auto__;
    var ch = cljs.tools.reader.impl.commons.read_past(cljs.tools.reader.impl.utils.whitespace_QMARK_, rdr);

    if (ch === "{") {
      var items = cljs.tools.reader.read_delimited(new cljs.core.Keyword(null, "namespaced-map", "namespaced-map", 1235665380), "}", rdr, opts, pending_forms);

      if (cljs.core.odd_QMARK_(cljs.core.count(items))) {
        cljs.tools.reader.impl.errors.throw_odd_map(rdr, null, null, items);
      } else {}

      var keys = cljs.tools.reader.impl.utils.namespace_keys(cljs.core.str.cljs$core$IFn$_invoke$arity$1(ns), cljs.core.take_nth.cljs$core$IFn$_invoke$arity$2(2, items));
      var vals = cljs.core.take_nth.cljs$core$IFn$_invoke$arity$2(2, cljs.core.rest(items));

      if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(cljs.core.count(cljs.core.set(keys)), cljs.core.count(keys))) {} else {
        cljs.tools.reader.impl.errors.throw_dup_keys(rdr, new cljs.core.Keyword(null, "namespaced-map", "namespaced-map", 1235665380), keys);
      }

      return cljs.core.zipmap(keys, vals);
    } else {
      return cljs.tools.reader.impl.errors.throw_ns_map_no_map(rdr, token);
    }
  } else {
    return cljs.tools.reader.impl.errors.throw_bad_ns(rdr, token);
  }
};

cljs.tools.reader.macros = function cljs$tools$reader$macros(ch) {
  var G__24818 = ch;

  switch (G__24818) {
    case "\"":
      return cljs.tools.reader.read_string_STAR_;
      break;

    case ":":
      return cljs.tools.reader.read_keyword;
      break;

    case ";":
      return cljs.tools.reader.impl.commons.read_comment;
      break;

    case "'":
      return cljs.tools.reader.wrapping_reader(new cljs.core.Symbol(null, "quote", "quote", 1377916282, null));
      break;

    case "@":
      return cljs.tools.reader.wrapping_reader(new cljs.core.Symbol("clojure.core", "deref", "clojure.core/deref", 188719157, null));
      break;

    case "^":
      return cljs.tools.reader.read_meta;
      break;

    case "`":
      return cljs.tools.reader.read_syntax_quote;
      break;

    case "~":
      return cljs.tools.reader.read_unquote;
      break;

    case "(":
      return cljs.tools.reader.read_list;
      break;

    case ")":
      return cljs.tools.reader.read_unmatched_delimiter;
      break;

    case "[":
      return cljs.tools.reader.read_vector;
      break;

    case "]":
      return cljs.tools.reader.read_unmatched_delimiter;
      break;

    case "{":
      return cljs.tools.reader.read_map;
      break;

    case "}":
      return cljs.tools.reader.read_unmatched_delimiter;
      break;

    case "\\":
      return cljs.tools.reader.read_char_STAR_;
      break;

    case "%":
      return cljs.tools.reader.read_arg;
      break;

    case "#":
      return cljs.tools.reader.read_dispatch;
      break;

    default:
      return null;
  }
};

cljs.tools.reader.dispatch_macros = function cljs$tools$reader$dispatch_macros(ch) {
  var G__24819 = ch;

  switch (G__24819) {
    case "^":
      return cljs.tools.reader.read_meta;
      break;

    case "'":
      return cljs.tools.reader.wrapping_reader(new cljs.core.Symbol(null, "var", "var", 870848730, null));
      break;

    case "(":
      return cljs.tools.reader.read_fn;
      break;

    case "{":
      return cljs.tools.reader.read_set;
      break;

    case "<":
      return cljs.tools.reader.impl.commons.throwing_reader("Unreadable form");
      break;

    case "=":
      return cljs.tools.reader.impl.commons.throwing_reader("read-eval not supported");
      break;

    case "\"":
      return cljs.tools.reader.read_regex;
      break;

    case "!":
      return cljs.tools.reader.impl.commons.read_comment;
      break;

    case "_":
      return cljs.tools.reader.read_discard;
      break;

    case "?":
      return cljs.tools.reader.read_cond;
      break;

    case ":":
      return cljs.tools.reader.read_namespaced_map;
      break;

    case "#":
      return cljs.tools.reader.read_symbolic_value;
      break;

    default:
      return null;
  }
};

cljs.tools.reader.read_tagged = function cljs$tools$reader$read_tagged(rdr, initch, opts, pending_forms) {
  var tag = cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms);

  if (!(tag instanceof cljs.core.Symbol)) {
    cljs.tools.reader.impl.errors.throw_bad_reader_tag(rdr, tag);
  } else {}

  if (cljs.core.truth_(cljs.tools.reader._STAR_suppress_read_STAR_)) {
    return cljs.core.tagged_literal(tag, cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms));
  } else {
    var temp__5802__auto__ = function () {
      var or__4126__auto__ = cljs.tools.reader._STAR_data_readers_STAR_.call(null, tag);

      if (cljs.core.truth_(or__4126__auto__)) {
        return or__4126__auto__;
      } else {
        return cljs.tools.reader.default_data_readers.cljs$core$IFn$_invoke$arity$1 ? cljs.tools.reader.default_data_readers.cljs$core$IFn$_invoke$arity$1(tag) : cljs.tools.reader.default_data_readers.call(null, tag);
      }
    }();

    if (cljs.core.truth_(temp__5802__auto__)) {
      var f = temp__5802__auto__;
      var G__24820 = cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms);
      return f.cljs$core$IFn$_invoke$arity$1 ? f.cljs$core$IFn$_invoke$arity$1(G__24820) : f.call(null, G__24820);
    } else {
      var temp__5802__auto____$1 = cljs.tools.reader._STAR_default_data_reader_fn_STAR_;

      if (cljs.core.truth_(temp__5802__auto____$1)) {
        var f = temp__5802__auto____$1;
        var G__24821 = tag;
        var G__24822 = cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 ? cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(rdr, true, null, opts, pending_forms) : cljs.tools.reader.read_STAR_.call(null, rdr, true, null, opts, pending_forms);
        return f.cljs$core$IFn$_invoke$arity$2 ? f.cljs$core$IFn$_invoke$arity$2(G__24821, G__24822) : f.call(null, G__24821, G__24822);
      } else {
        return cljs.tools.reader.impl.errors.throw_unknown_reader_tag(rdr, tag);
      }
    }
  }
};
/**
 * Map from reader tag symbols to data reader Vars.
 *   Reader tags without namespace qualifiers are reserved for Clojure.
 *   This light version of tools.reader has no implementation for default
 *   reader tags such as #inst and #uuid.
 */


cljs.tools.reader._STAR_data_readers_STAR_ = cljs.core.PersistentArrayMap.EMPTY;
/**
 * When no data reader is found for a tag and *default-data-reader-fn*
 *   is non-nil, it will be called with two arguments, the tag and the value.
 *   If *default-data-reader-fn* is nil (the default value), an exception
 *   will be thrown for the unknown tag.
 */

cljs.tools.reader._STAR_default_data_reader_fn_STAR_ = null;
cljs.tools.reader._STAR_suppress_read_STAR_ = false;
/**
 * Default map of data reader functions provided by Clojure.
 *   May be overridden by binding *data-readers*
 */

cljs.tools.reader.default_data_readers = cljs.core.PersistentArrayMap.EMPTY;

cljs.tools.reader.read_STAR__internal = function cljs$tools$reader$read_STAR__internal(reader, eof_error_QMARK_, sentinel, return_on, opts, pending_forms) {
  while (true) {
    if (cljs.tools.reader.reader_types.source_logging_reader_QMARK_(reader) && !cljs.tools.reader.impl.utils.whitespace_QMARK_(reader.cljs$tools$reader$reader_types$Reader$peek_char$arity$1(null))) {
      return cljs.tools.reader.reader_types.log_source_STAR_(reader, function () {
        while (true) {
          if (!goog.array.isEmpty(pending_forms)) {
            var form = pending_forms[0];
            goog.array.removeAt(pending_forms, 0);
            return form;
          } else {
            var ch = reader.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

            if (cljs.tools.reader.impl.utils.whitespace_QMARK_(ch)) {
              continue;
            } else {
              if (ch == null) {
                if (eof_error_QMARK_) {
                  return cljs.tools.reader.impl.errors.throw_eof_error(reader, null);
                } else {
                  return sentinel;
                }
              } else {
                if (ch === return_on) {
                  return cljs.tools.reader.READ_FINISHED;
                } else {
                  if (cljs.tools.reader.impl.commons.number_literal_QMARK_(reader, ch)) {
                    return cljs.tools.reader.read_number(reader, ch);
                  } else {
                    var f = cljs.tools.reader.macros(ch);

                    if (!(f == null)) {
                      var res = f.cljs$core$IFn$_invoke$arity$4 ? f.cljs$core$IFn$_invoke$arity$4(reader, ch, opts, pending_forms) : f.call(null, reader, ch, opts, pending_forms);

                      if (res === reader) {
                        continue;
                      } else {
                        return res;
                      }
                    } else {
                      return cljs.tools.reader.read_symbol(reader, ch);
                    }
                  }
                }
              }
            }
          }

          break;
        }
      });
    } else {
      if (!goog.array.isEmpty(pending_forms)) {
        var form = pending_forms[0];
        goog.array.removeAt(pending_forms, 0);
        return form;
      } else {
        var ch = reader.cljs$tools$reader$reader_types$Reader$read_char$arity$1(null);

        if (cljs.tools.reader.impl.utils.whitespace_QMARK_(ch)) {
          continue;
        } else {
          if (ch == null) {
            if (eof_error_QMARK_) {
              return cljs.tools.reader.impl.errors.throw_eof_error(reader, null);
            } else {
              return sentinel;
            }
          } else {
            if (ch === return_on) {
              return cljs.tools.reader.READ_FINISHED;
            } else {
              if (cljs.tools.reader.impl.commons.number_literal_QMARK_(reader, ch)) {
                return cljs.tools.reader.read_number(reader, ch);
              } else {
                var f = cljs.tools.reader.macros(ch);

                if (!(f == null)) {
                  var res = f.cljs$core$IFn$_invoke$arity$4 ? f.cljs$core$IFn$_invoke$arity$4(reader, ch, opts, pending_forms) : f.call(null, reader, ch, opts, pending_forms);

                  if (res === reader) {
                    continue;
                  } else {
                    return res;
                  }
                } else {
                  return cljs.tools.reader.read_symbol(reader, ch);
                }
              }
            }
          }
        }
      }
    }

    break;
  }
};

cljs.tools.reader.read_STAR_ = function cljs$tools$reader$read_STAR_(var_args) {
  var G__24824 = arguments.length;

  switch (G__24824) {
    case 5:
      return cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
      break;

    case 6:
      return cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$5 = function (reader, eof_error_QMARK_, sentinel, opts, pending_forms) {
  return cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6(reader, eof_error_QMARK_, sentinel, null, opts, pending_forms);
};

cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6 = function (reader, eof_error_QMARK_, sentinel, return_on, opts, pending_forms) {
  try {
    return cljs.tools.reader.read_STAR__internal(reader, eof_error_QMARK_, sentinel, return_on, opts, pending_forms);
  } catch (e24825) {
    if (e24825 instanceof Error) {
      var e = e24825;

      if (cljs.tools.reader.impl.utils.ex_info_QMARK_(e)) {
        var d = cljs.core.ex_data(e);

        if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword(null, "reader-exception", "reader-exception", -1938323098), new cljs.core.Keyword(null, "type", "type", 1174270348).cljs$core$IFn$_invoke$arity$1(d))) {
          throw e;
        } else {
          throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$3(e.message, cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "reader-exception", "reader-exception", -1938323098)], null), d, cljs.tools.reader.reader_types.indexing_reader_QMARK_(reader) ? new cljs.core.PersistentArrayMap(null, 3, [new cljs.core.Keyword(null, "line", "line", 212345235), reader.cljs$tools$reader$reader_types$IndexingReader$get_line_number$arity$1(null), new cljs.core.Keyword(null, "column", "column", 2078222095), reader.cljs$tools$reader$reader_types$IndexingReader$get_column_number$arity$1(null), new cljs.core.Keyword(null, "file", "file", -1269645878), reader.cljs$tools$reader$reader_types$IndexingReader$get_file_name$arity$1(null)], null) : null], 0)), e);
        }
      } else {
        throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$3(e.message, cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "type", "type", 1174270348), new cljs.core.Keyword(null, "reader-exception", "reader-exception", -1938323098)], null), cljs.tools.reader.reader_types.indexing_reader_QMARK_(reader) ? new cljs.core.PersistentArrayMap(null, 3, [new cljs.core.Keyword(null, "line", "line", 212345235), reader.cljs$tools$reader$reader_types$IndexingReader$get_line_number$arity$1(null), new cljs.core.Keyword(null, "column", "column", 2078222095), reader.cljs$tools$reader$reader_types$IndexingReader$get_column_number$arity$1(null), new cljs.core.Keyword(null, "file", "file", -1269645878), reader.cljs$tools$reader$reader_types$IndexingReader$get_file_name$arity$1(null)], null) : null], 0)), e);
      }
    } else {
      throw e24825;
    }
  }
};

cljs.tools.reader.read_STAR_.cljs$lang$maxFixedArity = 6;
/**
 * Reads the first object from an IPushbackReader.
 * Returns the object read. If EOF, throws if eof-error? is true.
 * Otherwise returns sentinel. If no stream is provided, *in* will be used.
 * 
 * Opts is a persistent map with valid keys:
 *  :read-cond - :allow to process reader conditionals, or
 *               :preserve to keep all branches
 *  :features - persistent set of feature keywords for reader conditionals
 *  :eof - on eof, return value unless :eofthrow, then throw.
 *         if not specified, will throw
 * 
 * To read data structures only, use cljs.tools.reader.edn/read
 * 
 * Note that the function signature of cljs.tools.reader/read and
 * cljs.tools.reader.edn/read is not the same for eof-handling
 */

cljs.tools.reader.read = function cljs$tools$reader$read(var_args) {
  var G__24827 = arguments.length;

  switch (G__24827) {
    case 1:
      return cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$1 = function (reader) {
  return cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$3(reader, true, null);
};

cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$2 = function (p__24828, reader) {
  var map__24829 = p__24828;
  var map__24829__$1 = (!(map__24829 == null) ? map__24829.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__24829.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__24829) : map__24829;
  var opts = map__24829__$1;
  var eof = cljs.core.get.cljs$core$IFn$_invoke$arity$3(map__24829__$1, new cljs.core.Keyword(null, "eof", "eof", -489063237), new cljs.core.Keyword(null, "eofthrow", "eofthrow", -334166531));
  return cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6(reader, cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(eof, new cljs.core.Keyword(null, "eofthrow", "eofthrow", -334166531)), eof, null, opts, cljs.core.to_array(cljs.core.PersistentVector.EMPTY));
};

cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$3 = function (reader, eof_error_QMARK_, sentinel) {
  return cljs.tools.reader.read_STAR_.cljs$core$IFn$_invoke$arity$6(reader, eof_error_QMARK_, sentinel, null, cljs.core.PersistentArrayMap.EMPTY, cljs.core.to_array(cljs.core.PersistentVector.EMPTY));
};

cljs.tools.reader.read.cljs$lang$maxFixedArity = 3;
/**
 * Reads one object from the string s.
 * Returns nil when s is nil or empty.
 * 
 * To read data structures only, use cljs.tools.reader.edn/read-string
 * 
 * Note that the function signature of cljs.tools.reader/read-string and
 * cljs.tools.reader.edn/read-string is not the same for eof-handling
 */

cljs.tools.reader.read_string = function cljs$tools$reader$read_string(var_args) {
  var G__24832 = arguments.length;

  switch (G__24832) {
    case 1:
      return cljs.tools.reader.read_string.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return cljs.tools.reader.read_string.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

cljs.tools.reader.read_string.cljs$core$IFn$_invoke$arity$1 = function (s) {
  return cljs.tools.reader.read_string.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, s);
};

cljs.tools.reader.read_string.cljs$core$IFn$_invoke$arity$2 = function (opts, s) {
  if (cljs.core.truth_(function () {
    var and__4115__auto__ = s;

    if (cljs.core.truth_(and__4115__auto__)) {
      return !(s === "");
    } else {
      return and__4115__auto__;
    }
  }())) {
    return cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$2(opts, cljs.tools.reader.reader_types.string_push_back_reader.cljs$core$IFn$_invoke$arity$1(s));
  } else {
    return null;
  }
};

cljs.tools.reader.read_string.cljs$lang$maxFixedArity = 2;
/**
 * Like read, and taking the same args. reader must be a SourceLoggingPushbackReader.
 *   Returns a vector containing the object read and the (whitespace-trimmed) string read.
 */

cljs.tools.reader.read_PLUS_string = function cljs$tools$reader$read_PLUS_string(var_args) {
  var G__24834 = arguments.length;

  switch (G__24834) {
    case 1:
      return cljs.tools.reader.read_PLUS_string.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 3:
      return cljs.tools.reader.read_PLUS_string.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    case 2:
      return cljs.tools.reader.read_PLUS_string.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

cljs.tools.reader.read_PLUS_string.cljs$core$IFn$_invoke$arity$1 = function (stream) {
  return cljs.tools.reader.read_PLUS_string.cljs$core$IFn$_invoke$arity$3(stream, true, null);
};

cljs.tools.reader.read_PLUS_string.cljs$core$IFn$_invoke$arity$3 = function (stream, eof_error_QMARK_, eof_value) {
  var buf = function buf(reader) {
    return cljs.core.str.cljs$core$IFn$_invoke$arity$1(new cljs.core.Keyword(null, "buffer", "buffer", 617295198).cljs$core$IFn$_invoke$arity$1(cljs.core.deref(stream.frames)));
  };

  var offset = buf(stream).length;
  var o = cljs.tools.reader.reader_types.source_logging_reader_QMARK_(stream) && !cljs.tools.reader.impl.utils.whitespace_QMARK_(cljs.tools.reader.reader_types.peek_char(stream)) ? cljs.tools.reader.reader_types.log_source_STAR_(stream, function () {
    return cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$3(stream, eof_error_QMARK_, eof_value);
  }) : cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$3(stream, eof_error_QMARK_, eof_value);
  var s = cljs.core.subs.cljs$core$IFn$_invoke$arity$2(buf(stream), offset).trim();
  return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [o, s], null);
};

cljs.tools.reader.read_PLUS_string.cljs$core$IFn$_invoke$arity$2 = function (opts, stream) {
  var buf = function buf(reader) {
    return cljs.core.str.cljs$core$IFn$_invoke$arity$1(new cljs.core.Keyword(null, "buffer", "buffer", 617295198).cljs$core$IFn$_invoke$arity$1(cljs.core.deref(stream.frames)));
  };

  var offset = buf(stream).length;
  var o = cljs.tools.reader.reader_types.source_logging_reader_QMARK_(stream) && !cljs.tools.reader.impl.utils.whitespace_QMARK_(cljs.tools.reader.reader_types.peek_char(stream)) ? cljs.tools.reader.reader_types.log_source_STAR_(stream, function () {
    return cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$2(opts, stream);
  }) : cljs.tools.reader.read.cljs$core$IFn$_invoke$arity$2(opts, stream);
  var s = cljs.core.subs.cljs$core$IFn$_invoke$arity$2(buf(stream), offset).trim();
  return new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [o, s], null);
};

cljs.tools.reader.read_PLUS_string.cljs$lang$maxFixedArity = 3;
Object.defineProperty(module.exports, "NO_MATCH", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.NO_MATCH;
  }
});
Object.defineProperty(module.exports, "READ_EOF", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.READ_EOF;
  }
});
Object.defineProperty(module.exports, "unquote_splicing_QMARK_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.unquote_splicing_QMARK_;
  }
});
Object.defineProperty(module.exports, "read_symbolic_value", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_symbolic_value;
  }
});
Object.defineProperty(module.exports, "read_tagged", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_tagged;
  }
});
Object.defineProperty(module.exports, "starting_line_col_info", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.starting_line_col_info;
  }
});
Object.defineProperty(module.exports, "wrapping_reader", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.wrapping_reader;
  }
});
Object.defineProperty(module.exports, "resolve_alias", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.resolve_alias;
  }
});
Object.defineProperty(module.exports, "read_PLUS_string", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_PLUS_string;
  }
});
Object.defineProperty(module.exports, "read_meta", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_meta;
  }
});
Object.defineProperty(module.exports, "read_unicode_char", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_unicode_char;
  }
});
Object.defineProperty(module.exports, "read_unmatched_delimiter", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_unmatched_delimiter;
  }
});
Object.defineProperty(module.exports, "read_fn", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_fn;
  }
});
Object.defineProperty(module.exports, "syntax_quote_STAR_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.syntax_quote_STAR_;
  }
});
Object.defineProperty(module.exports, "bool_QMARK_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.bool_QMARK_;
  }
});
Object.defineProperty(module.exports, "arg_env", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.arg_env;
  }
});
Object.defineProperty(module.exports, "read_suppress", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_suppress;
  }
});
Object.defineProperty(module.exports, "_STAR_suppress_read_STAR_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader._STAR_suppress_read_STAR_;
  }
});
Object.defineProperty(module.exports, "flatten_map", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.flatten_map;
  }
});
Object.defineProperty(module.exports, "_STAR_default_data_reader_fn_STAR_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader._STAR_default_data_reader_fn_STAR_;
  }
});
Object.defineProperty(module.exports, "read", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read;
  }
});
Object.defineProperty(module.exports, "read_set", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_set;
  }
});
Object.defineProperty(module.exports, "read_symbol", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_symbol;
  }
});
Object.defineProperty(module.exports, "read_unquote", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_unquote;
  }
});
Object.defineProperty(module.exports, "read_map", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_map;
  }
});
Object.defineProperty(module.exports, "read_STAR__internal", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_STAR__internal;
  }
});
Object.defineProperty(module.exports, "unquote_QMARK_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.unquote_QMARK_;
  }
});
Object.defineProperty(module.exports, "default_data_readers", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.default_data_readers;
  }
});
Object.defineProperty(module.exports, "macros", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.macros;
  }
});
Object.defineProperty(module.exports, "read_arg", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_arg;
  }
});
Object.defineProperty(module.exports, "match_feature", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.match_feature;
  }
});
Object.defineProperty(module.exports, "read_namespaced_map", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_namespaced_map;
  }
});
Object.defineProperty(module.exports, "read_syntax_quote", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_syntax_quote;
  }
});
Object.defineProperty(module.exports, "READ_FINISHED", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.READ_FINISHED;
  }
});
Object.defineProperty(module.exports, "read_list", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_list;
  }
});
Object.defineProperty(module.exports, "read_cond_delimited", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_cond_delimited;
  }
});
Object.defineProperty(module.exports, "RESERVED_FEATURES", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.RESERVED_FEATURES;
  }
});
Object.defineProperty(module.exports, "dispatch_macros", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.dispatch_macros;
  }
});
Object.defineProperty(module.exports, "read_STAR_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_STAR_;
  }
});
Object.defineProperty(module.exports, "_STAR_data_readers_STAR_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader._STAR_data_readers_STAR_;
  }
});
Object.defineProperty(module.exports, "syntax_quote_coll", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.syntax_quote_coll;
  }
});
Object.defineProperty(module.exports, "_STAR_read_delim_STAR_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader._STAR_read_delim_STAR_;
  }
});
Object.defineProperty(module.exports, "resolve_symbol", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.resolve_symbol;
  }
});
Object.defineProperty(module.exports, "read_delimited", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_delimited;
  }
});
Object.defineProperty(module.exports, "read_token", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_token;
  }
});
Object.defineProperty(module.exports, "read_cond", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_cond;
  }
});
Object.defineProperty(module.exports, "upper_limit", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.upper_limit;
  }
});
Object.defineProperty(module.exports, "loc_info", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.loc_info;
  }
});
Object.defineProperty(module.exports, "gensym_env", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.gensym_env;
  }
});
Object.defineProperty(module.exports, "_STAR_alias_map_STAR_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader._STAR_alias_map_STAR_;
  }
});
Object.defineProperty(module.exports, "read_regex", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_regex;
  }
});
Object.defineProperty(module.exports, "sb", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.sb;
  }
});
Object.defineProperty(module.exports, "read_dispatch", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_dispatch;
  }
});
Object.defineProperty(module.exports, "check_eof_error", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.check_eof_error;
  }
});
Object.defineProperty(module.exports, "check_invalid_read_cond", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.check_invalid_read_cond;
  }
});
Object.defineProperty(module.exports, "read_string", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_string;
  }
});
Object.defineProperty(module.exports, "check_reserved_features", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.check_reserved_features;
  }
});
Object.defineProperty(module.exports, "has_feature_QMARK_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.has_feature_QMARK_;
  }
});
Object.defineProperty(module.exports, "valid_octal_QMARK_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.valid_octal_QMARK_;
  }
});
Object.defineProperty(module.exports, "escape_char", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.escape_char;
  }
});
Object.defineProperty(module.exports, "read_char_STAR_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_char_STAR_;
  }
});
Object.defineProperty(module.exports, "resolve_ns", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.resolve_ns;
  }
});
Object.defineProperty(module.exports, "read_delimited_internal", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_delimited_internal;
  }
});
Object.defineProperty(module.exports, "read_string_STAR_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_string_STAR_;
  }
});
Object.defineProperty(module.exports, "macro_terminating_QMARK_", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.macro_terminating_QMARK_;
  }
});
Object.defineProperty(module.exports, "map_func", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.map_func;
  }
});
Object.defineProperty(module.exports, "lower_limit", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.lower_limit;
  }
});
Object.defineProperty(module.exports, "ending_line_col_info", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.ending_line_col_info;
  }
});
Object.defineProperty(module.exports, "register_arg", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.register_arg;
  }
});
Object.defineProperty(module.exports, "read_keyword", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_keyword;
  }
});
Object.defineProperty(module.exports, "read_discard", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_discard;
  }
});
Object.defineProperty(module.exports, "garg", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.garg;
  }
});
Object.defineProperty(module.exports, "read_vector", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_vector;
  }
});
Object.defineProperty(module.exports, "read_number", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.read_number;
  }
});
Object.defineProperty(module.exports, "add_meta", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.add_meta;
  }
});
Object.defineProperty(module.exports, "register_gensym", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.register_gensym;
  }
});
Object.defineProperty(module.exports, "expand_list", {
  enumerable: false,
  get: function get() {
    return cljs.tools.reader.expand_list;
  }
});